"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Ads API
 * The Spotify Ads API.
 *
 * The version of the OpenAPI document: 3.0.0
 * Contact: selfserve-infra-api@spotify.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.CreateMobileAppRequestToJSON = exports.CreateMobileAppRequestFromJSONTyped = exports.CreateMobileAppRequestFromJSON = exports.instanceOfCreateMobileAppRequest = void 0;
var runtime_1 = require("../runtime");
var MobileApp_1 = require("./MobileApp");
/**
 * Check if a given object implements the CreateMobileAppRequest interface.
 */
function instanceOfCreateMobileAppRequest(value) {
    var isInstance = true;
    return isInstance;
}
exports.instanceOfCreateMobileAppRequest = instanceOfCreateMobileAppRequest;
function CreateMobileAppRequestFromJSON(json) {
    return CreateMobileAppRequestFromJSONTyped(json, false);
}
exports.CreateMobileAppRequestFromJSON = CreateMobileAppRequestFromJSON;
function CreateMobileAppRequestFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'mobileApp': !(0, runtime_1.exists)(json, 'mobile_app') ? undefined : (0, MobileApp_1.MobileAppFromJSON)(json['mobile_app']),
    };
}
exports.CreateMobileAppRequestFromJSONTyped = CreateMobileAppRequestFromJSONTyped;
function CreateMobileAppRequestToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'mobile_app': (0, MobileApp_1.MobileAppToJSON)(value.mobileApp),
    };
}
exports.CreateMobileAppRequestToJSON = CreateMobileAppRequestToJSON;
